<template>
    <div class="page-start">
        <mdb-row class="justify-content-center">
        <mdb-col col="10">
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p1" @closeAlert="p1=false" dismiss>
                There was an error retrieving saved wars! Please try again later.
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3" @closeAlert="p3=false" dismiss>
              Success! The WAR Report has been deleted.
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="info" v-if="p2" @closeAlert="p2=false" dismiss>
                There was an error deleting the WAR Report.
            </mdb-alert>
            
            <QDataTable ref="warTable" id='warTable' :rowData="this.data.rows" :filterWords="this.data.filterWords" :headers="this.data.columns" 
                :btnName="'EDIT'" :hasBtn="true" @use-method="editRouter" :deleteName="'Delete'" :hasDelete="true" @delete="deleteWAR" 
                 @deleteInfo="WARInfo" :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
                <h5>Do you want to delete this WAR report?</h5>
                <hr>
                    <ul class="text-left">
                        <li>Project: {{ this.projectTask }}</li>
                        <li>Date: {{ this.saveDate }}</li>
                    </ul>
            </QDataTable>

            <div :class="{'hideSpinner': isSetUp}" class="p-4">
                <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
              </div>
        </mdb-col>
        </mdb-row>
    </div>
</template>

<script>
import { mdbCol, mdbRow, mdbAlert } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import {identifyStringFormat} from '@/assets/js/JSONorHTML.js';
import {convertJSON} from '@/assets/js/JSONtoHTML.js';


export default {
    name: 'EditSavedWar',
    components: {
        mdbCol,
        mdbRow,
        mdbAlert,
        QDataTable,
    },
    data() {
        return {
            isSetUp: false,
            p1: false,
            p2: false,
            p3: false,

            id: '',
            projectTask: '',
            saveDate: '',

            data: {
                columns: [
                    {
                        colTitle: 'Date Range',
                        sortBy: 'dateSaved'
                    },
                    {
                        colTitle: 'Project',
                        sortBy: 'projectTask'
                    },
                    {
                        colTitle: 'Action',
                        sortBy: ''
                    }
                ],
                rows: [],
                filterWords: [
                    'dateSaved',
                    'projectTask'
                ]
            },
        }
    },
    methods: {
        editSavedWar: function(idParam, projectTaskParam, activityParam) {
            this.$router.push(
                { name: 'New-War', params: { id: idParam, projectTask: projectTaskParam, activity: activityParam }}
            );
        },

        WARInfo: function(data){
            this.id = data.id;
            this.projectTask = data.projectTask;
            this.saveDate = data.dateSaved;
        },

        deleteWAR: async function(){
            this.$refs.warTable.closeDeleteModal();
            try{
                await DatabaseLib.deleteRequest('strapiDatabase','war-reports',this.$store.getters.getToken,this.id);
                this.p3 = true;
            } catch(error){
                console.log(error);
                this.p2 = true;
            }
            this.data.rows = [];
            this.fillTable();
            window.scroll({top: 0, behavior: 'smooth'});
        },

        editRouter: function(data) {
            if(identifyStringFormat(data.activity) == "JSON"){
                data.activity = convertJSON(data.activity);
            }

            let propData = {
                id: data.id,
                projectTask: data.projectTask,
                activity: data.activity,
                startDate: data.startDate,
                endDate: data.endDate,
                editing: true
            }
            this.$router.push({
                name: 'New-War',
                params: {
                    editWAR: propData
                }
            })
        },

        fillTable: async function() {
            try {
                let token = this.$store.getters.getToken;
                let query = 'filters[submitted][$eq][0]='+false+'&filters[username][$eq][1]='+this.$store.getters.getUser;

                let response = await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
                response.data.data.forEach(tableRow => {
                    this.data.rows.push({
                        id: tableRow.id,
                        projectTask: tableRow.attributes.projectTask,
                        activity: tableRow.attributes.activity,
                        startDate: tableRow.attributes.startDate,
                        endDate: tableRow.attributes.endDate,
                        dateSaved: tableRow.attributes.startDate + " - " + tableRow.attributes.endDate
                    })
                });
                this.isSetUp = true;
			} catch(error) {
                window.scroll({top: 0, behavior: 'smooth'});
				this.p1 = true;
                this.isSetUp = true;
                return;
            }
            return 0;
        }
    },

    mounted() {
        this.fillTable();
	}
}
</script>